<script>
import dropdown from "@/components/form components/dropdown";
import { Datetime } from "vue-datetime";

export default {
  name: "auction-edit",
  components: {
    dropdown,
    Datetime,
  },
  props: {
    auctionId: String,
    visible: Boolean,
  },
  data: function() {
    return {
      auction: {
        id: "",
        requirementId: "",
        bids: [],
        auctionStart: "",
        status: "",
        duration: 10,
        minIncrement: 0,
        currency: "",
        fuelCost: "",
        fuelUnit: "",
        includeFuelCost: false,
      },

      isVisible: this.visible || false,
    };
  },
  methods: {
    onModalClose: function() {
      this.$emit("hide");
    },
    async getAuctionData() {
      this.auction = await this.$store.dispatch("getRequest", { controller: "auction", method: "getAuction", parameters: { id: this.auctionId } });
    },
    async saveAuction() {
            this.$store.commit("setLoadingAnimation", {
        show: true,
        text: `${this.auction.id ? 'Saving Auction Changes' : 'Creating Auction'}`
      });
      var d = new Date();
      var n = d.getTimezoneOffset();
      this.auction.auctionStart = new Date(this.auction.auctionStart).toISOString();
      var isUpdated = await this.$store.dispatch("postRequest", { controller: "auction", method:`${this.auction.id ? 'Update' : 'Create'}`, parameters: this.auction });
      if (isUpdated === false || isUpdated === null) {
        this.$store.commit("setMessage", { title: "Something Went Wrong", type: "error", content: `Unable to ${this.auctionId ? "update" : "create"} auction` });
      } else {
        this.$emit("refreshTable");
        this.isVisible = false;
        var requirementsDataSource = await this.$store.dispatch("getRequest", { controller: "requirement", method: `getRequirements`, parameters: { open: true, kvPairs: true } });
        this.$store.commit("setAvailableRequirements", requirementsDataSource);
      }
      this.$store.commit("hideLoadingAnimation");
      if (!this.auction.id){
        this.$router.push(`/auction/${isUpdated.id}`);
      }
    },
    async onRequirementChange(){
      
    },
        updateFuelCost: function(value) {
      this.auction.fuelCost = value ? parseInt(value.replace(/\,/g, "")) : null;
    },
        setFuelUnit: function(u) {
      this.auction.fuelUnit = u;
    },
        addCommas: function(x) {
      if (x === null) {
        return null;
      } else if (isNaN(x)) {
        return 0;
      }
      var parts = x.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    },
  },
  computed: {
    activeAuction: function() {
      return this.$store.state.activeAuction;
    },
    isRequirementDisabled: function() {
      return this.$store.state.auctionFromSeabay;
    },
     isEdit: function(){
                       if (!this.auction){

                         
        return false;
      }else{
        return this.auction.id ? true : false;
      }
    },
    canSave: function(){
      var a = this.auction;
      return (a.auctionStart && a.requirementId && a.duration && a.minIncrement && a.currency) ? true : false;
    },
        availableRequirements: function() {
      return this.$store.state.availableRequirements;
    },
        unitDisplay: function() {
      var u = this.auction.fuelUnit;
      if (!u) {
        return "--Select Unit--";
      } else if (u == "M") {
        return "per m³ ";
      } else {
        return "per tonne";
      }
        }
  },
  async mounted() {
    if (this.auctionId) {
      await this.getAuctionData();
    }
  },
  watch: {
    visible: function(value) {
      this.isVisible = value;
    },
    activeAuction: {
      async handler(val) {
        var self = this;
        self.auction = val;
      },
      deep: true,
    },
  },
};
</script>
<template>
  <div v-if="auction">
    <b-modal :id="isEdit ? `edit-auction-${auction.id}-modal` : `add-auction-modal`" :title="auction.id  ? `Edit Auction` : `Create Auction`" v-on:hidden="onModalClose" v-model="isVisible">
      <div class="row">
        <div class="col-lg-12">
          <dropdown v-on:change="onRequirementChange" v-if="!isEdit && availableRequirements.length" :disabled="isRequirementDisabled" label="Requirement" v-model="auction.requirementId" :inputValue="auction.requirementId" :dataSource="availableRequirements"></dropdown>
          <div style="margin-bottom:0.5rem;" v-else>
          <label>Requirement</label><br/>
          <i> {{auction.requirementSummary}}</i>
          </div>

          <div>
            <label>Start Time</label>
            <datetime type="datetime" value-zone="local" :auto="true" v-model="auction.auctionStart"></datetime>
          </div>

          <div style="margin-bottom:0.5rem;">
            <label>Duration (minutes)</label>
            <input v-model.number="auction.duration" type="number" class="form-control" style="width:100%" placeholder="Duration (in minutes)" ></input>
          </div>
          <label>Min Decriment</label>
          <input class="form-control"  type = "number" label="Min Decriment" v-model.number="auction.minIncrement" :inputValue="parseInt(auction.minIncrement)" :min="5"></input>

          <dropdown label="Currency" v-model="auction.currency" :inputValue="auction.currency" dataSourceController="lookup" dataSourceMethod="GetCurrencies"></dropdown>
                 <b-form-checkbox v-model="auction.includeFuelCost" :value="true" :unchecked-value="false">
            <span class="title-text">Include Fuel Cost in Rate</span>
          </b-form-checkbox>
                      <b-input-group size="lg" :prepend="auction.currency" v-if="auction.includeFuelCost">
              <b-form-input :value="addCommas(auction.fuelCost)" v-on:input.native="updateFuelCost($event.target.value)"></b-form-input>
              <template v-slot:append>
                <b-dropdown :text="unitDisplay" variant="success">
                  <b-dropdown-item v-on:click="setFuelUnit('M')"> per m&sup3;</b-dropdown-item>
                  <b-dropdown-item v-on:click="setFuelUnit('T')">per tonne</b-dropdown-item>
                </b-dropdown>
              </template>
            </b-input-group>
        </div>
      </div>
      <template v-slot:modal-footer="{ ok, cancel }">
        <div class="row" style="width:100%">
        <div class="col-6" style="padding-left:0px;">
        <b-button size="sm" variant="danger" block  v-on:click="cancel()">
          Cancel
        </b-button>
        </div>
                <div class="col-6" style="padding-right:0px;">
        <b-button :disabled="!canSave" size="sm" variant="success" block  v-on:click="saveAuction()">
          {{ !auction.id ? "Create" : `Save Changes` }}
        </b-button>
        </div>
        </div>




      </template>
    </b-modal>
  </div>
</template>
